module.exports = __webpack_public_path__ + "static/media/Intelo-SemiBold.cc9f984e.ttf";